(() => {
  if (window.mlPredictiveLoaded) return;
  window.mlPredictiveLoaded = true;
  const cache = new Map();
  let sequence = 0;
  function enhance(original) {
    if (original.dataset.mlReady) return;
    let form = original;
    // Replace the legacy predictive host so its listeners cannot compete with this one.
    const legacy = form.closest('predictive-search');
    if (legacy) {
      const host = document.createElement('div');
      host.className = 'ml-predictive-host';
      form = original.cloneNode(true);
      host.append(form);
      legacy.replaceWith(host);
    }
    form.dataset.mlReady = 'true';
    form.classList.add('ml-search-form');
    form.querySelectorAll('[data-predictive-search],.predictive-search-status').forEach(el => el.remove());
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    for (const [name, value] of [['type', 'product'], ['options[prefix]', 'last']]) {
      let field = form.querySelector(`input[name="${name}"]`);
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.append(field); }
      field.value = value;
    }
    const id = 'ml-suggest-' + (++sequence);
    const popup = document.createElement('div');
    popup.id = id; popup.className = 'ml-suggest'; popup.hidden = true;
    popup.setAttribute('role', 'listbox'); popup.setAttribute('aria-label', 'Sökförslag');
    const announcer = document.createElement('span');
    announcer.className = 'visually-hidden'; announcer.setAttribute('role', 'status');
    form.append(popup, announcer);
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id); input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-owns'); input.setAttribute('aria-haspopup', 'listbox');
    input.autocomplete = 'off';
    let timer, controller, request = 0, active = -1, links = [];
    const searchUrl = term => { const url = new URL(form.action, location.href); url.search = new URLSearchParams({q: term, type: 'product', 'options[prefix]': 'last'}); return url; };
    function close() {
      popup.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant');
      active = -1; request++; clearTimeout(timer); controller?.abort();
    }
    function present(fragment) {
      popup.replaceChildren(fragment);
      links = [...popup.querySelectorAll('a')]; active = -1;
      links.forEach((link, i) => { link.id = `${id}-${i}`; link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false'); });
      popup.hidden = false; input.setAttribute('aria-expanded', 'true'); input.removeAttribute('aria-activedescendant');
      announcer.textContent = `${popup.querySelectorAll('.ml-suggest-product').length} produktförslag. Använd piltangenterna för att välja.`;
    }
    function message(text, term) {
      const box = document.createElement('div'), p = document.createElement('p'), a = document.createElement('a');
      p.className = 'ml-suggest-empty'; p.textContent = text;
      a.className = 'ml-suggest-all'; a.href = searchUrl(term); a.textContent = `Visa alla resultat för “${term}” →`;
      box.append(p, a); present(box);
    }
    function discover() {
      const box = document.createElement('div'), label = document.createElement('p'), chips = document.createElement('div');
      box.className = 'ml-suggest-discover'; label.className = 'ml-suggest-label'; label.textContent = 'Vad letar du efter?';
      chips.className = 'ml-suggest-chips';
      ['Ultra X7', 'Dammsugare', 'Filter', 'Batteri'].forEach(term => { const a = document.createElement('a'); a.href = searchUrl(term); a.textContent = term; chips.append(a); });
      box.append(label, chips); present(box); announcer.textContent = 'Skriv för att se produktförslag.';
    }
    async function load() {
      const term = input.value.trim(), token = ++request;
      controller?.abort();
      if (!term) { discover(); return; }
      const url = new URL(form.action.replace(/\/$/, '') + '/suggest', location.href);
      url.search = new URLSearchParams({q: term, 'resources[type]': 'product,query,collection', 'resources[limit]': '6', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'last', section_id: 'maxlager-predictive-search'});
      const key = url.href;
      if (cache.has(key)) { present(cache.get(key).cloneNode(true)); return; }
      message('Söker efter produkter…', term);
      controller = new AbortController();
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('search');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-ml-suggestions]');
        if (!results) throw new Error('search');
        if (token !== request || input.value.trim() !== term || !form.contains(document.activeElement)) return;
        if (cache.size >= 20) cache.delete(cache.keys().next().value);
        cache.set(key, results.cloneNode(true)); present(results);
      } catch (error) {
        if (error.name !== 'AbortError' && token === request) message('Förslagen kunde inte laddas. Du kan fortfarande söka bland alla produkter.', term);
      }
    }
    input.addEventListener('input', () => { clearTimeout(timer); controller?.abort(); request++; input.removeAttribute('aria-activedescendant'); active = -1; timer = setTimeout(load, 200); });
    input.addEventListener('focus', load);
    input.addEventListener('click', () => { if (popup.hidden) load(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) { event.preventDefault(); event.stopPropagation(); close(); return; }
      if (event.key === 'Enter' && active >= 0 && !popup.hidden) { event.preventDefault(); links[active].click(); return; }
      if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
        if (popup.hidden) { event.preventDefault(); load(); return; }
        if (!links.length) return;
        event.preventDefault(); active = (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach((link, i) => link.setAttribute('aria-selected', String(i === active)));
        input.setAttribute('aria-activedescendant', links[active].id); links[active].scrollIntoView({block: 'nearest'});
      }
    });
    form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
    document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
    form.addEventListener('submit', () => { input.value = input.value.trim(); close(); });
    form.addEventListener('reset', () => { close(); setTimeout(() => { input.value = ''; input.focus(); discover(); }, 0); });
  }
  function init() { document.querySelectorAll('form.ml-desktop-search,form.search-modal__form,form[data-ml-search-form]').forEach(enhance); }
  init(); document.addEventListener('shopify:section:load', init);
})();
